import React from 'react';
import { SaveCancelButton } from '../../components';
import s from './HostStyles.module.scss';

const SaveCancelButtonEditor = () => (
    <div className={s.editor} style={{ padding: '100px' }}>
        <div style={{ width: '500px' }}>
            <SaveCancelButton changeCount={5} />
            <br />
            <SaveCancelButton changeCount={0} saveDisabled />
        </div>
    </div>
);

export default SaveCancelButtonEditor;
